export const getSeverityColor = (severity: string) => {
  switch (severity) {
    case 'CRITICAL':
      return 'bg-destructive text-destructive-foreground hover:bg-destructive/90';
    case 'HIGH':
      return 'bg-[hsl(30_80%_55%)] text-white hover:bg-[hsl(30_80%_45%)]';
    case 'MEDIUM':
      return 'bg-[hsl(45_90%_55%)] text-black hover:bg-[hsl(45_90%_45%)]';
    case 'LOW':
      return 'bg-[hsl(220_70%_50%)] text-white hover:bg-[hsl(220_70%_40%)]';
    default:
      return 'bg-muted text-muted-foreground hover:bg-muted/80';
  }
};

export const getSeverityProgress = (severity: string) => {
  switch (severity) {
    case 'CRITICAL':
      return 100;
    case 'HIGH':
      return 75;
    case 'MEDIUM':
      return 50;
    case 'LOW':
      return 25;
    default:
      return 0;
  }
};

export const getSeverityColorValue = (severity: string) => {
  switch (severity) {
    case 'CRITICAL':
      return 'hsl(0 84.2% 60.2%)';
    case 'HIGH':
      return 'hsl(30 80% 55%)';
    case 'MEDIUM':
      return 'hsl(45 90% 55%)';
    case 'LOW':
      return 'hsl(220 70% 50%)';
    default:
      return 'hsl(var(--muted))';
  }
};

export const formatCVSS = (score: number): string => {
  return score.toFixed(1);
};
